import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { default as PartnerMediaModel } from '../../models/partnerMedia';
import MediaList from './mediaList';
import Loading from '../../components/loading';
import { ToastContext } from '@weezevent/nacre';

const PartnerMediaList = ({ organization, partnerId }) => {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);
    const [medias, setMedias] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    const updateImage = React.useCallback(
        (image, media, type) => {
            if (!image) {
                return media
                    .delete({ organizationId: organization.id, partnerId })
                    .then(() => {
                        toast.success(t('ticket.partners.medias.success.delete'));
                        let tmpMedias = medias.filter(media => media.type !== type);
                        setMedias(tmpMedias);
                    })
                    .catch(e => {
                        console.error(e);
                        toast.error(t('ticket.partners.medias.error.delete'));
                    });
            }
            media.path = image.path;
            media.type = type;
            media.partnerId = partnerId;
            media.url = image.url;
            media
                .save({ organizationId: organization.id, partnerId })
                .then(({ response }) => {
                    toast.success(t('ticket.partners.medias.success.update'));
                    let tmpMedias = [...medias];
                    media.uuid = response.uuid;
                    tmpMedias.push(media);
                    setMedias([...tmpMedias]);
                })
                .catch(e => {
                    console.error(e);
                    toast.error(t('ticket.partners.medias.error.update'));
                });
        },
        [partnerId, toast, organization, medias, setMedias]
    );

    React.useEffect(() => {
        if (partnerId) {
            PartnerMediaModel.getAll({
                partnerId,
                organizationId: organization.id
            })
                .then(medias => {
                    setMedias(medias);
                })
                .catch(e => {
                    console.error(e);
                    toast.error(t('ticket.partners.get.mediaError'));
                })
                .finally(() => setLoading(false));
        }
    }, [partnerId]);

    if (loading) return <Loading />;

    return (
        <>
            <MediaList organization={organization} medias={medias} updateImage={updateImage} />
        </>
    );
};

export default PartnerMediaList;
PartnerMediaList.propTypes = {
    organization: PropTypes.object.isRequired,
    partnerId: PropTypes.string
};
